<user-navigation></user-navigation>

<div id="exerciseConfirmation">
    <section class="h-100">
      <header class="container h-100">
        <div class="d-flex align-items-center justify-content-center h-100">
          <div class="confirmation-body">
            <h4 class="text-center">Continue to Breathing Exercise</h4>
            <p class="text-center mt-3 mt-md-3 mb-5 mb-md-5">Would you like to continue to the 60 second breathing<br>exercise or go back to the homepage?</p>

            <div class="row">
              <div class="col-md-12 d-flex justify-content-center align-items-center">
                <button class="btn btn-primary btn-homepage mr-3 mr-md-3" [routerLink]="['/user/dashboard']">Homepage</button>
                <button
                  class="btn btn-primary btn-exercise"
                  [routerLink]="['/user/breathing-exerise/', seriesId, moduleId]"
                  [queryParams]="{exercise_active: true}"
                >
                  Breath Exercise
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </section>
  </div>

<div class="container-fluid">
    <div class="row no-gutter transform-translate">
        <div class="col-xl-3 d-none d-sm-none d-md-none d-lg-none d-xl-block">
            <series-navigation></series-navigation>
        </div>
        <div class="col-xl-9 d-xl-block embed-responsive embed-responsive-16by9" id="video-container" *ngIf="module">
            <div
                plyr
                [plyrOptions]="{hideControls: false}"
                [plyrPlaysInline]="true"
                [plyrSources]="module?.video_url"
                (plyrInit)="videoPlayer = $event"
                id="videoPlayer"
                (plyrEnded)="ended($event)"
                (plyrSeeking)="seeking($event)"
                (plyrPlay)="play($event)"
                (plyrPause)="pause($event)"
                (plyrTimeUpdate)="timeupdate($event)"
                class="embed-responsive-item"
                style="height: 100%;padding-top: 0px;"
            >
            </div>
        </div>
    </div>

    <!-- Series Mobile Navigation -->
    <div class="row d-block d-sm-block d-md-block d-lg-block d-xl-none mobile-series-navigation-with-fixed-video" id="mobile-series-navigation">

      <!-- Fixed module title and details -->
      <div class="col-md-12 module-title-box mobile-video-desc-div" [ngStyle]="{'background-color': '#' + activeModuleBgColor}" style="border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
        <div style="padding: 20px 25px;">
        <a class="module-title align-items-center">
          <span class="moduleNumber">Module {{ activeModuleNo }}</span><br>
          <span class="moduleName">{{ activeModuleName }}</span>
        </a>
        </div>
      </div>

      <div class="col-md-12 module-title-box mobile-video-desc-div d-flex py-3 justify-content-center" [ngStyle]="{'background-color': '#' + activeModuleBgColor}">
        <div class="text-center px-2" [routerLink]="['/user/videos/', seriesId, moduleId]">
          <img class="module-badge-icon standard" src="../../../../assets/images/icons/video.svg"><br>
          <span class="d-inline-block align-middle ml-md-2">Video</span>
        </div>
        <div class="text-center px-2" *ngIf="activeModuleQuiz" [routerLink]="['/user/quiz/', seriesId, moduleId]">
            <img class="module-badge-icon standard" src="../../../../assets/images/icons/quiz.svg"><br>
            <span class="d-inline-block align-middle ml-2 ml-md-2">Quiz</span>
        </div>
        <div class="text-center px-2"  *ngIf="activeModuleSummary" [routerLink]="['/user/summary/', seriesId, moduleId]">
          <img class="module-badge-icon standard" src="../../../../assets/images/icons/summary.svg"><br>
          <span class="d-inline-block align-middle ml-2 ml-md-2">Summary</span>
        </div>
        <div class="text-center px-2"  [routerLink]="['/user/breathing-exerise/', seriesId, moduleId]">
          <img class="module-badge-icon standard" src="../../../../assets/images/icons/exercise.svg"><br>
          <span class="d-inline-block align-middle ml-2 ml-md-2">Exercise</span>
        </div>
      </div>

      <div *ngFor="let list of series">
        <ng-container *ngIf="list.modules.length > 0">

            <div class="section-title text-left text-sm-center text-md-center p-3 mt-5">
                <span>{{ 'Series ' + list.sequence_number }}</span>
                <p class="mx-0">{{ list.series_name }}</p>
            </div>

            <div class="row no-gutters module-container justify-content-xs-center justify-content-sm-center justify-content-lg-center">
                <div *ngFor="let module of list.modules" class="col-12 col-xs-8 col-sm-8 col-md-4 module-item p-3">
                    <div  class="mobile_module_scroll" [id]="'mobile_module_scroll_' + list.series_id + '_' + module.id">&nbsp;</div>
                    <div class="module-wrap">
                      <!--
                        <a
                            (click)="reloadPage(list.series_id, module.id)"
                            [routerLink]="['/user/videos/', list.series_id, module.id]"
                            [queryParams]="{video_active: true}"
                        >
                            <div class="d-flex justify-content-center align-item-center" [id]="'mobile_module_image_container_' + list.series_id + '_' + module.id">
                                <img
                                    [defaultImage]="preloaderImage"
                                    [lazyLoad]="module.cover_url"
                                    class="module-image img-fluid"
                                    [id]="'mobile_module_image_' + list.series_id + '_' + module.id"
                                    (onStateChange)="moduleImageCallback($event, list.series_id, module.id)"
                                >
                            </div>
                            <div
                                class="mobile-badge-points mobile-badge-points-block"
                                [id]="'mobile_module_badge_points_' + list.series_id + '_' + module.id"
                            >
                                <img class="module-badge-icon" src="../../../../assets/images/icons/award.svg">
                                <span class="d-inline-block align-middle ml-1 ml-md-1" *ngIf="module.points > 0">{{ module.points + '/' + module.totalAvailablePoints }} points</span>
                                <span class="d-inline-block align-middle ml-1 ml-md-1" *ngIf="!module.points">{{ '0/' + module.totalAvailablePoints }} points</span>
                            </div>
                            <div [id]="'mobile_module_play_' + list.series_id + '_' + module.id" class="d-none justify-content-center align-items-middle">

                                <img src="../../../../assets/images/icons/play.svg">

                            </div>
                        </a>
                      -->
                        <div class="module-info" [ngStyle]="{'background-color': '#' + module.cover_color}">
                            <div
                                class="mobile-badge-videos d-none"
                                *ngIf="module.video_completed; else notWatched"
                                [id]="'mobile_module_badge_video_' + list.series_id + '_' + module.id"
                            >
                                <img class="module-badge-icon" src="../../../../assets/images/icons/check.svg">
                                <span class="d-inline-block align-middle ml-1 ml-md-1">Watched</span>
                            </div>
                            <ng-template #notWatched>
                                <div
                                    class="mobile-badge-videos d-none"
                                    [id]="'mobile_module_badge_video_duration_' + list.series_id + '_' + module.id"
                                >
                                    <img class="module-badge-icon" src="../../../../assets/images/icons/video_time.svg">
                                    <span class="d-inline-block align-middle ml-1 ml-md-1">{{ module.video_duration }}</span>
                                </div>
                            </ng-template>
                            <div
                                class="col-md-12 module-title-box"
                                [id]="'mobile_module_title_' + list.series_id + '_' + module.id"
                                [ngClass]="{'resize-module-title-box': seriesId == list.series_id && moduleId == module.id}"
                                (click)="showModuleLinks(list.series_id, module.id)"
                            >
                                <!-- <a data-toggle="collapse" [href]="'#module_' + list.series_id + '_' + module.id"
                                    aria-expanded="false" [attr.aria-controls]="'module_' + list.series_id + '_' + module.id"
                                    class="font-weight-bold module-title align-items-center">
                                    {{ module.name }}
                                    <span><i class="fa fa-chevron-down pull-right"></i></span>
                                </a> -->
                                <a class="module-title align-items-center">
                                    <span class="moduleNumber">{{ 'Module ' + module.moduleNo }}</span>
                                    <span class="module-direction-icon">
                                        <i
                                            class="module-title-arrow-icon fa fa-angle-down pull-right"
                                            [id]="'mobile_module_title_icon_' + list.series_id + '_' + module.id"
                                        >
                                        </i>
                                    </span><br>
                                    <span class="module-name">{{ module.name }}</span>
                                    <p class="mt-4 mb-0">{{ module.description }}</p>
                                </a>
                            </div>
                            <div class="collapse"
                              [ngClass]="{'show': seriesId == list.series_id && moduleId == module.id}"
                              [id]="'mobile_module_' + list.series_id + '_' + module.id">
                                <ul class="pl-md-0 pl-0">
                                    <li
                                        [routerLink]="['/user/videos/', list.series_id, module.id]"
                                        [queryParams]="{video_active: true}"
                                        [id]="'link_video_' + list.series_id + '_' + module.id"
                                    >
                                        <a
                                            [ngClass]="{'active': module.video_completed ||
                                                videosActive && seriesId == list.series_id && moduleId == module.id}"
                                        >
                                            <img class="module-badge-icon standard" src="../../../../assets/images/icons/video.svg">
                                            <span class="d-inline-block align-middle ml-md-2">Video</span>
                                            <div class="pull-right" *ngIf="module.video_completed">
                                                <img class="module-badge-icon action" src="../../../../assets/images/icons/check.svg">
                                            </div>
                                        </a>
                                    </li>
                                    <li
                                        *ngIf="module.quiz == 1"
                                        [routerLink]="['/user/quiz/', list.series_id, module.id]"
                                        [id]="'link_quiz_' + list.series_id + '_' + module.id"
                                        [queryParams]="{quiz_active: true}"
                                    >
                                        <a
                                            [ngClass]="{'active': module.quiz_completed ||
                                                quizActive && seriesId == list.series_id && moduleId == module.id}"
                                        >
                                            <img class="module-badge-icon standard" src="../../../../assets/images/icons/quiz.svg">
                                            <span class="d-inline-block align-middle ml-2 ml-md-2">Quiz</span>
                                            <div class="pull-right" *ngIf="module.quiz_completed">
                                                <img class="module-badge-icon action" src="../../../../assets/images/icons/check.svg">
                                            </div>
                                        </a>
                                    </li>
                                    <li
                                        *ngIf="module.summary == 1"
                                        [routerLink]="['/user/summary/', list.series_id, module.id]"
                                        [id]="'link_summary_' + list.series_id + '_' + module.id"
                                        [queryParams]="{summary_active: true}"
                                    >
                                        <a
                                            [ngClass]="{'active': module.summary_completed ||
                                                summaryActive && seriesId == list.series_id && moduleId == module.id}"
                                        >
                                            <img class="module-badge-icon standard" src="../../../../assets/images/icons/summary.svg">
                                            <span class="d-inline-block align-middle ml-2 ml-md-2">Summary</span>
                                            <div class="pull-right" *ngIf="module.summary_completed">
                                                <img class="module-badge-icon action" src="../../../../assets/images/icons/check.svg">
                                            </div>
                                        </a>
                                    </li>
                                    <li
                                        [routerLink]="['/user/breathing-exerise/', list.series_id, module.id]"
                                        [id]="'link_exercise_' + list.series_id + '_' + module.id"
                                        [queryParams]="{exercise_active: true}"
                                    >
                                        <a
                                            [ngClass]="{'active': module.exercise_completed ||
                                                exerciseActive && seriesId == list.series_id && moduleId == module.id}"
                                        >
                                            <img class="module-badge-icon standard" src="../../../../assets/images/icons/exercise.svg">
                                            <span class="d-inline-block align-middle ml-2 ml-md-2">Breath Exercise</span>
                                            <div class="pull-right" *ngIf="module.exercise_completed">
                                                <img class="module-badge-icon action" src="../../../../assets/images/icons/check.svg">
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>
